import { IonContent, IonIcon, IonImg, IonItem, IonList, IonListHeader, IonMenu, IonMenuToggle, IonNote, IonText } from "@ionic/react";

import {
  calendar,
  calendarOutline,
  documents,
  documentsOutline,
  informationCircle,
  informationCircleOutline,
  logOut,
  logOutOutline,
  mail,
  mailOutline,
  medkit,
  medkitOutline,
  search,
  searchOutline,
  today,
  todayOutline,
} from "ionicons/icons";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSession } from "../../hooks/SessionContext";
import { LateralMenuOption, Paciente } from "../../interfaces";
import ModalEditorEvoluciones from "../Modales/ModalEditorEvoluciones";
import ModalPdfsPaciente from "../Modales/ModalPdfsPaciente";
import ModalPedido from "../Modales/ModalPedido";
import ModalPrivacidad from "../Modales/ModalPrivacidad";
import ModalTurnosPaciente from "../Modales/ModalTurnosPaciente";

interface ContainerProps {}

const Menu: React.FC<ContainerProps> = ({}) => {
  const [appPages, setAppPages] = useState<LateralMenuOption[]>();
  const [modalEvolucion, setModalEvolucion] = useState<boolean>(false);
  const [modalPedido, setModalPedido] = useState<boolean>(false);
  const [modalTurnos, setModalTurnos] = useState<boolean>(false);
  const [modalPdfs, setModalPdfs] = useState<boolean>(false);
  const [modalPrivacidad, setModalPrivacidad] = useState<boolean>(false);
  const [cerradaPorAgregar, setCerradaPorAgregar] = useState<boolean>(false);

  const { hcUL, cargandoSession, setHcUL, pacienteCargado, setPacienteCargado, setTurnoSeleccionado, setAgendaCargada, mostrarNotificacion } =
    useSession();
  const location = useLocation();
  const history = useHistory();

  const redirigirLogin = (): void => {
    setHcUL(null);
    setPacienteCargado(null);
    setTurnoSeleccionado(null);
    setAgendaCargada(null);
    history.push("/");
  };

  const handleClickVolverAgenda = (): void => {
    setPacienteCargado(null);
    setTurnoSeleccionado(null);

    history.push("/portal/Agenda");
  };

  const handleClickBuscarPaciente = () => {
    setPacienteCargado(null);
    setTurnoSeleccionado(null);
  };

  const handleClickMostrarModal = (id: string): void => {
    switch (id) {
      case "evolucion":
        setModalEvolucion(true);
        break;
      case "pedido":
        setModalPedido(true);
        break;
      case "turnos":
        setModalTurnos(true);
        break;
      case "pdfs":
        setModalPdfs(true);
        break;
      case "privacidad":
        setModalPrivacidad(true);
        break;
      default:
        mostrarNotificacion(true, "Seleccion inválida", "rojo");
        break;
    }
  };

  const RemakeLateralMenu = () => {
    let pacienteTmp: Paciente | null = pacienteCargado;
    let itemsMenu: LateralMenuOption[] = [
      {
        iosIcon: todayOutline,
        mdIcon: today,
        title: "Agenda",
        url: "/portal/Agenda",
        detail: false,
        br: false,
      },
      {
        iosIcon: searchOutline,
        mdIcon: search,
        title: "Buscar Paciente",
        url: "/portal/Paciente",
        detail: false,
        br: false,
      },
      {
        iosIcon: medkitOutline,
        mdIcon: medkit,
        title: "Nuevo Turno",
        url: "/portal/Nuevo Turno",
        detail: false,
        br: false,
      },
    ];

    if (pacienteTmp !== null && pacienteTmp?.codigo !== 0) {
      if (location.pathname === "/portal/Paciente") {
        itemsMenu = [
          {
            iosIcon: todayOutline,
            mdIcon: today,
            title: "Volver a la Agenda",
            url: "/portal/Agenda",
            handleClickItem: handleClickVolverAgenda,
            detail: false,
            br: false,
          },
          {
            iosIcon: searchOutline,
            mdIcon: search,
            title: "Buscar otro Paciente",
            handleClickItem: handleClickBuscarPaciente,
            detail: false,
            br: false,
          },
          {
            iosIcon: calendarOutline,
            mdIcon: calendar,
            title: "Historial de Turnos",
            handleClickItem: () => handleClickMostrarModal("turnos"),
            detail: false,
            br: false,
          },
          {
            iosIcon: documentsOutline,
            mdIcon: documents,
            title: "Pdfs Paciente",
            handleClickItem: () => handleClickMostrarModal("pdfs"),
            detail: false,
            br: false,
          },
          {
            iosIcon: mailOutline,
            mdIcon: mail,
            title: "Nuevo Pedido",
            handleClickItem: () => handleClickMostrarModal("pedido"),
            detail: false,
            br: false,
          },
          {
            iosIcon: medkitOutline,
            mdIcon: medkit,
            title: "Nuevo Turno",
            url: "/portal/Nuevo Turno",
            detail: false,
            br: false,
          },
        ];
      }
      if (location.pathname === "/portal/Nuevo Turno") {
        itemsMenu = [
          {
            iosIcon: todayOutline,
            mdIcon: today,
            title: "Volver a la agenda",
            url: "/portal/Agenda",
            detail: false,
            br: false,
          },
          {
            iosIcon: medkitOutline,
            mdIcon: medkit,
            title: "Volver a la ficha",
            url: "/portal/Paciente",
            detail: false,
            br: false,
          },
        ];
      }
    }

    itemsMenu.push(
      {
        iosIcon: informationCircleOutline,
        mdIcon: informationCircle,
        title: "Política de Privacidad",
        handleClickItem: () => handleClickMostrarModal("privacidad"),
        detail: false,
        br: true,
      },
      {
        title: "CERRAR SESION",
        color: "danger",
        leftIosIcon: logOutOutline,
        leftMdIcon: logOut,
        detail: false,
        handleClickItem: redirigirLogin,
        br: false,
      }
    );

    setAppPages(itemsMenu);
  };

  useEffect(() => {
    RemakeLateralMenu();
  }, [location, pacienteCargado]);

  useEffect(() => {
    if (cerradaPorAgregar) {
      setCerradaPorAgregar(false);
      window.location.reload();
    }
  }, [modalEvolucion]);

  const handleClickOption = (option: LateralMenuOption) => {
    if (option?.url) {
      history.push(option?.url, { pushFrom: location.pathname });
    } else if (option?.handleClickItem) {
      option?.handleClickItem();
    } else {
      console.log("Metodo y url inexistente");
    }
  };

  return (
    <IonMenu contentId="main" type="push">
      <IonContent>
        <IonImg src="assets/icon/logo.jpg" style={{ width: "60%", margin: "0 auto" }} />
        <IonList id="inbox-list">
          <IonListHeader>{hcUL?.nombreCompleto}</IonListHeader>
          <IonNote>{hcUL?.especialidadNom}</IonNote>

          {appPages?.map((appPage, index) => {
            return (
              <IonMenuToggle key={index} autoHide={false}>
                {appPage.br && <br />}
                <IonItem
                  className={location.pathname === appPage.url ? "selected" : ""}
                  routerDirection="none"
                  lines="none"
                  detail={appPage.detail}
                  button
                  onClick={() => handleClickOption(appPage)}
                >
                  {appPage?.iosIcon && appPage?.mdIcon && (
                    <IonIcon aria-hidden="true" slot="start" ios={appPage.iosIcon} md={appPage.mdIcon} color={appPage?.color ? appPage?.color : ""} />
                  )}

                  <IonText color={appPage?.color ? appPage?.color : ""}>{appPage.title}</IonText>
                  {appPage?.leftIosIcon && appPage?.leftMdIcon && (
                    <IonIcon
                      aria-hidden="true"
                      slot="end"
                      ios={appPage.leftIosIcon}
                      md={appPage.leftMdIcon}
                      color={appPage?.color ? appPage?.color : ""}
                    />
                  )}
                </IonItem>
              </IonMenuToggle>
            );
          })}
        </IonList>
        {/* Tema controlado por preferencia del sistema (prefers-color-scheme) */}
        {hcUL && pacienteCargado && (
          <>
            <ModalEditorEvoluciones abrirModal={modalEvolucion} setAbrirModal={setModalEvolucion} setCerradaPorConfirmar={setCerradaPorAgregar} />

            <ModalPedido abrirModal={modalPedido} setAbrirModal={setModalPedido} />

            <ModalPdfsPaciente abrirModal={modalPdfs} setAbrirModal={setModalPdfs} />

            <ModalTurnosPaciente abrirModal={modalTurnos} setAbrirModal={setModalTurnos} />
          </>
        )}
        <ModalPrivacidad abrirModal={modalPrivacidad} setAbrirModal={setModalPrivacidad} />
      </IonContent>
    </IonMenu>
  );
};

export default Menu;
